export const SET_TOKEN = 'SET_TOKEN'
export const RESET_LOGIN = 'RESET_LOGIN'
export const SET_ROLES = 'SET_ROLES'
export const SET_PASSTHROUGH = 'SET_PASSTHROUGH'
export const SET_CONTACT = 'SET_CONTACT'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const SET_LOCATION_KEY = 'SET_LOCATION_KEY'
export const SET_BUSINESS_USERS = 'SET_BUSINESS_USERS'
export const IS_NEW = 'IS_NEW'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_USER_INFO = 'SET_USER_INFO'

export const SESSION_ROLES_NAME = 'auth/roles'
export const SESSION_TOKEN_NAME = 'auth/token'
export const SESSION_USER_PROFILE = 'auth/profile'
export const SESSION_USER_TOKEN = 'auth/usertoken'
export const SESSION_PRIMARY_ROLE = 'auth/primaryRole'
export const SESSION_LANGUAGE = 'auth/language'
export const SESSION_CHANNELTYPE = 'channelType'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js